import { render, staticRenderFns } from "./courseLeadersListItem.vue?vue&type=template&id=133c1aec&scoped=true&lang=pug&"
import script from "./courseLeadersListItem.vue?vue&type=script&lang=js&"
export * from "./courseLeadersListItem.vue?vue&type=script&lang=js&"
import style0 from "./courseLeadersListItem.vue?vue&type=style&index=0&id=133c1aec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133c1aec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VIcon,VSwitch})
